import { FinancialsObjectType } from '../constants';

export const FINANCIALS_EVENT_NAME = 'FINANCIALS' as const;

export const FINANCIALS_ACTIONS = {
  ADD_FINANCIALS: 'ADD_FINANCIALS',
  VIEW_FINANCIALS: 'VIEW_FINANCIALS',
  EDIT_FINANCIALS: 'EDIT_FINANCIALS',
  UPDATE_FINANCIALS: 'UPDATE_FINANCIALS',
} as const;

export const FINANCIALS_LOCATIONS = {
  OKR_WIZARD: 'OKR_WIZARD',
  OKR_POPUP: 'OKR_POPUP',
  KEY_RESULT_PAGE: 'KEY_RESULT_PAGE',
} as const;

export const FINANCIALS_OBJECTS = {
  OBJECTIVE: 'OBJECTIVE',
  KEY_RESULT: 'KEY_RESULT',
} as const;

export const FINANCIALS_SOURCES = {
  MANUAL: 'MANUAL',
  EXCEL: 'EXCEL',
} as const;

export type FinancialsTrackingProps = {
  action: (typeof FINANCIALS_ACTIONS)[keyof typeof FINANCIALS_ACTIONS];
  location: (typeof FINANCIALS_LOCATIONS)[keyof typeof FINANCIALS_LOCATIONS];
  object: (typeof FINANCIALS_OBJECTS)[keyof typeof FINANCIALS_OBJECTS];
  source?: (typeof FINANCIALS_SOURCES)[keyof typeof FINANCIALS_SOURCES];
};

export function trackFinancialsEvent(
  action: FinancialsTrackingProps['action'],
  props: Omit<FinancialsTrackingProps, 'action'>,
): void {
  window.wb_track(FINANCIALS_EVENT_NAME, {
    action,
    ...props,
  });
}

export function getObjectFromObjectType(
  objectType: number,
): (typeof FINANCIALS_OBJECTS)[keyof typeof FINANCIALS_OBJECTS] {
  return objectType === FinancialsObjectType.OKR
    ? FINANCIALS_OBJECTS.OBJECTIVE
    : FINANCIALS_OBJECTS.KEY_RESULT;
}
